<template>
  <div>
    <b-row>
      <b-col sm="8" class="form-group" v-if="!readonly">
        <form-write-group-label-input 
          v-model="BIC" 
          isMandatory
          id="bic-input"
          :inputLabel="$t('common.global.bic')"
          class="h5 font-weight-bold text-dark bg-light p-3 border rounded">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="8" class="form-group" v-else>
        <form-read-group-label-input 
          isMandatory
          id="bic-display"
          :inputLabel="$t('common.global.bic')"
          :inputValue="BIC"
          class="h5 font-weight-bold text-dark bg-light p-3 border rounded">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: "BICOnusForm",
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    // selectedGroupBICs() {
    //   return this.emailGroupList
    //     .filter(groupEmail => groupEmail.state === groupEmail.id)
    //     .map(groupEmail => groupEmail.text)
    //     .join(', ')
    // },
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    BIC: {
      get () {
        return this.inputValue.BIC
      },
      set (val) {
        this.inputValue = {
          BIC: val,
        }
      }
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  watch: {
    IdMetricsKey (newVal, oldVal) {
      if (newVal) {
        this.inputValue.IdThresholdUnit = undefined
        this.updateThresholdUnitList()
      }
    }
  },
  methods: {
    updateThresholdUnitList () {
      if (this.IdMetricsKey) {
        if (this.allThresholdUnits){
          this.thresholdUnitList = this.allThresholdUnits.filter(unit => {
            return unit.idMetricsKey === this.IdMetricsKey
          })
        }
      } else {
        this.thresholdUnitList = []
      }
    },
  }
}
</script>
